import React, { useState } from "react";
import "./CreateServiceMain.css";
import Widgets from "../../../../widgets";
import { useTranslation } from "react-i18next";
const dummyOptions = [
  { value: "home", label: "Home" },
  { value: "work", label: "Work" },
  { value: "relative", label: "Relative" },
  { value: "other", label: "Other" },
];
const ServiceType = () => {
  const { t } = useTranslation();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const handleServiceGroupModal = () => {
    setIsOpenModal(true);
  };
  const handleCreate = (description) => {
    console.log("Description:", description); // Handle the description (e.g., save it)
    alert(`Description created: ${description}`);
  };
  return (
    <div className="service-type-main">
      <div className="service-input-box">
        <span>
          {t("serviceType")} <label>*</label>
        </span>
        <Widgets.NewSelectDropdown options={dummyOptions} placeholder={"select"} big />
      </div>
      <div className="group-input-box">
        <div className="service-input-box">
          <span>
            {t("serviceGroup")} <label>*</label>
          </span>
          <Widgets.NewSelectDropdown options={dummyOptions} placeholder={"select"} big />
          <p onClick={handleServiceGroupModal}>{t("service-group")}</p>
        </div>
        <div className="service-input-box">
          <span>
            {t("subServiceGroup")} <label>*</label>
          </span>
          <Widgets.NewSelectDropdown options={dummyOptions} placeholder={"select"} big />
          <p>{t("sub-serviceGroup")}</p>
        </div>
        <div className="service-input-box">
          <span>
            {t("serviceItem")} <label>*</label>
          </span>
          <Widgets.NewSelectDropdown options={dummyOptions} placeholder={"select"} big />
        </div>
      </div>
      <div className="service-input-box">
        <span>
          {t("serviceCode")} <label>*</label>
        </span>
        <Widgets.NewSelectDropdown options={dummyOptions} placeholder={"select"} big />
      </div>
      <Widgets.TextModal isOpen={isOpenModal} onClose={() => setIsOpenModal(false)} title="Create Item" onCreate={handleCreate} position={{ top: "83%", left: "30%", position: "absolute" }} />
    </div>
  );
};

export default ServiceType;
